import { useMemo } from "react";
import { GlobalStyles, ThemeProvider } from "@mui/material";
import { useColorMode } from "../../../contexts/ColorModeContext";
import { buildCadastrosMuiTheme } from "./theme";
import {
  DARK_CONTENT_VARS,
  LIGHT_CONTENT_VARS,
  buildLegacyContentOverrides,
} from "./contentTokens";
import { CadastrosPageActionsProvider } from "./CadastrosPageActionsContext";

/**
 * Provider do layout MUI de Cadastros.
 * Consome o ColorMode global e aplica o tema/tokens do módulo.
 */
const CadastrosMuiProvider = ({ children }) => {
  const { mode } = useColorMode();

  const theme = useMemo(() => buildCadastrosMuiTheme(mode), [mode]);
  const contentVars = mode === "dark" ? DARK_CONTENT_VARS : LIGHT_CONTENT_VARS;
  const legacyOverrides = useMemo(
    () =>
      buildLegacyContentOverrides(mode, {
        rootSelector: '[data-cad-mui-mode="dark"]',
        contentSelector: ".cad-mui-content",
      }),
    [mode]
  );

  return (
    <ThemeProvider theme={theme}>
      <GlobalStyles
        styles={{
          "[data-cad-mui-mode]": contentVars,
          ...legacyOverrides,
        }}
      />
      <CadastrosPageActionsProvider>{children}</CadastrosPageActionsProvider>
    </ThemeProvider>
  );
};

export default CadastrosMuiProvider;
